import type { PalantirChatHeaderAction } from '@flux/design-system';

/**
 * Ids das ações que o painel flutuante acrescenta ao cabeçalho do `palantir-chat`.
 * União fechada para o handler comparar com segurança em vez de casar string solta.
 */
export type IaraPanelHeaderActionId = 'expand';

/**
 * O `testId` é contrato com o e2e: `iara-floating-chat.e2e.ts` clica em
 * `iara-panel-expand` para validar F11. Renomear aqui quebra aquele cenário.
 */
export const IARA_PANEL_HEADER_ACTIONS: PalantirChatHeaderAction<IaraPanelHeaderActionId>[] = [
  {
    icon: 'open-external-outline',
    id: 'expand',
    label: 'Abrir no chat completo',
    testId: 'iara-panel-expand',
  },
];
